import { Component, inject, Input, OnInit } from '@angular/core';

import { DateTime } from 'luxon';

import { WorkedShiftsService } from '../services/worked-shifts.service';
import { BehaviorSubject, combineLatest, filter, map, mergeMap, of, switchMap, tap } from 'rxjs';
import { BrowserProviderService } from '../services/browser-provider.service';
import { AuthService } from '../authentication/auth.service';

@Component({
    selector: '[theme-footer]',
    templateUrl: './theme.footer.component.html',
    standalone: false
})
export class ThemeFooterComponent implements OnInit {
    private readonly _buildNumber = new BehaviorSubject<string>('');

    @Input() set buildNumber(val: string) {
        this._buildNumber.next(val);
    }

    isPropak: boolean = false;

    loadTime: string = DateTime.local().toISO();


    year: number = (new Date()).getFullYear();

    workedShiftConnectionStatus: string = 'unknown';

    constructor(
        private browser: BrowserProviderService,
        private authService: AuthService) {
    }

    statusString = combineLatest([
        this.authService.isAuthenticated().pipe(
            mergeMap(authenticated => {
                if (authenticated) {
                    const workedShiftsService = inject(WorkedShiftsService);
                    return workedShiftsService.ConnectionStatus;
                } else {
                    return of('unavailable');
                }
            }),
            tap(status => this.workedShiftConnectionStatus = status)
        ),
        of(DateTime.local().toISO()),
        this._buildNumber
    ]).pipe(map(([wsConnStatus, pageLoadTime, buildNumber]) => {
        return 'Build ' + buildNumber
            + ' loaded at ' + pageLoadTime
            + '\nhub status: ' + wsConnStatus
            + '\nTZ: ' + DateTime.local().toFormat('z (ZZ)');
    }));

    ngOnInit() {
        this.isPropak = this.browser.GetLocation().hostname.endsWith('propak.com');
    }
}
